import { render, staticRenderFns } from "./ChapterSelector.vue?vue&type=template&id=6ca13a1a&"
import script from "./ChapterSelector.vue?vue&type=script&lang=js&"
export * from "./ChapterSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports